export var UserAgentUtil;
(function (UserAgentUtil) {
    let OsType;
    (function (OsType) {
        OsType[OsType["None"] = 0] = "None";
        OsType[OsType["Unknown"] = 1] = "Unknown";
        OsType[OsType["Windows"] = 2] = "Windows";
        OsType[OsType["MacOS"] = 3] = "MacOS";
        OsType[OsType["Android"] = 4] = "Android";
        OsType[OsType["iOS"] = 5] = "iOS";
    })(OsType = UserAgentUtil.OsType || (UserAgentUtil.OsType = {}));
    function getOsType() {
        const ua = window.navigator.userAgent.toLowerCase();
        if (ua.indexOf("windows nt") !== -1) {
            return OsType.Windows;
        }
        else if (ua.indexOf("android") !== -1) {
            return OsType.Android;
        }
        else if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
            return OsType.iOS;
        }
        else if (ua.indexOf("mac os x") !== -1) {
            return OsType.MacOS;
        }
        else {
            return OsType.Unknown;
        }
    }
    UserAgentUtil.getOsType = getOsType;
    function isSmartPhone(osType) {
        switch (osType) {
            case OsType.Android:
            case OsType.iOS:
                return true;
            default:
                return false;
        }
    }
    UserAgentUtil.isSmartPhone = isSmartPhone;
    function getMetaKeyName() {
        const osType = getOsType();
        switch (osType) {
            case OsType.Windows:
                return 'Ctrl';
            case OsType.MacOS:
                return 'Command';
            default:
                return '';
        }
    }
    UserAgentUtil.getMetaKeyName = getMetaKeyName;
    function isPressingMetaKey(event) {
        const osType = getOsType();
        switch (osType) {
            case OsType.Windows:
                return event.ctrlKey;
            case OsType.MacOS:
                return event.metaKey;
            default:
                return false;
        }
    }
    UserAgentUtil.isPressingMetaKey = isPressingMetaKey;
    function getZipMimeType() {
        const osType = UserAgentUtil.getOsType();
        let zipMimeType = 'application/zip';
        if (osType === UserAgentUtil.OsType.Windows) {
            zipMimeType = 'application/x-zip-compressed';
        }
        return zipMimeType;
    }
    UserAgentUtil.getZipMimeType = getZipMimeType;
})(UserAgentUtil || (UserAgentUtil = {}));
